// extracted by mini-css-extract-plugin
export default {"pageContainer":"RecordCheckPage_pageContainer__8a9Pr","pageWrapper":"RecordCheckPage_pageWrapper__pYQVr","pageWrapper__header":"RecordCheckPage_pageWrapper__header__k6dUl"};